const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-resources');

/**
 * Explorer Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('explorer', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/learn/v3/explore/:search/:category', null, {
    find: {method: 'GET', isArray: false},
    search: {params: {search: 'search'}, method: 'GET', isArray: false},
    getUserAccess: {params: {search: 'user-access'}, method: 'GET', isArray: false},
    ordering: {params: {search: 'ordering', category: ''}, method: 'GET', isArray: false}
  });

}]);

